import { render, staticRenderFns } from "./EduKnowledge.vue?vue&type=template&id=00d86b4b&scoped=true"
import script from "./EduKnowledge.vue?vue&type=script&lang=js"
export * from "./EduKnowledge.vue?vue&type=script&lang=js"
import style0 from "./EduKnowledge.vue?vue&type=style&index=0&id=00d86b4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d86b4b",
  null
  
)

export default component.exports